import React from 'react';
import { connect } from 'react-redux';
import {Modal, Button} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

class EditItemModal extends React.Component {
  constructor(){
    super();

    this.state = {
      submitting: false
    }
  }

  doSubmit(){
    const { editItem={} } = this.props;
    const { handleSubmit } = this.props;
    const { onClose=()=>Promise.resolve() } = this.props;

    this.setState({
      submitting: true
    });

    handleSubmit(editItem.attributes)
      .then(() => {
        this.setState({
          submitting: false
        });
      })
      .then(() => onClose())
      .catch(() => {
        this.setState({
          submitting: false
        });
      });
  }

  render(){
    const { modelPath=`editItem`} = this.props;
    const { editItem } = this.props;

    const { newItemTitle, editItemTitle } = this.props;

    const { body : Body } = this.props;
    const { submitting } = this.state;

    return <div className="static-modal">
      <Modal show animation={false} backdrop='static' keyboard={false}>
        <Modal.Header>
          <Modal.Title>{editItem && editItem.attributes && editItem.attributes.id ? editItemTitle : newItemTitle}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Body item={editItem.attributes} modelPath={modelPath}/>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => this.props.onClose()}>Close</Button>
          { submitting ?
            <a className="btn btn-primary" disabled><FontAwesome name="spinner" spin/> Submitting...</a>
            :
            <a className="btn btn-primary" onClick={() => this.doSubmit()}>Submit</a>
          }
        </Modal.Footer>

      </Modal>
    </div>
  }
}

function mapStateToProps(state, ownProps){
  const { modelPath } = ownProps;

  return {
    editItem: state[modelPath]
  }
}

export default connect(mapStateToProps)(EditItemModal);
